import { useMemo } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { layoutMobileMediaQuery } from '../../layout/layoutConstants'

export function useReportPieChartMetrics({ compact = false } = {}) {
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)

  return useMemo(() => {
    if (isMobileLayout) {
      return {
        isMobileLayout,
        chartSize: 168,
        innerRadius: 41,
        radius: 69,
        legendMaxHeight: 180,
        gridGap: 2
      }
    }
    if (compact) {
      return {
        isMobileLayout,
        chartSize: 132,
        innerRadius: 32,
        radius: 54,
        legendMaxHeight: 160,
        gridGap: 1.25
      }
    }
    return {
      isMobileLayout,
      chartSize: 132,
      innerRadius: 32,
      radius: 54,
      legendMaxHeight: 148,
      gridGap: 1.25
    }
  }, [isMobileLayout, compact])
}
